/** Deck slides → Drive video ids, for the screen content slide picker. */
export default function toPresentation(pres) {
  const videos = {};
  (pres.slides || []).forEach((s) => {
    const fileId = s.video?.url?.match(/\/file\/d\/([a-zA-Z0-9_-]+)/)?.[1];
    if (fileId) videos[s.index] = fileId;
  });
  return { id: pres.id, slideCount: pres.slide_count, videos };
}
